import { User } from '@/features/member/member.type'
import { Locales } from '@/utils/language'

interface GetReviewVisibilityParams {
  user?: Pick<User, 'id'> | null
  locale: string
}

export const getReviewVisibility = ({ user, locale }: GetReviewVisibilityParams) => {
  // 일본 서비스(ja-JP)에서는 로그인 여부와 관계없이 리뷰를 보여줍니다.
  const isJapan = locale === Locales.JA_JP

  // 그 외 국가에서는 로그인한 사용자에게만 리뷰를 보여줍니다.
  const isLoggedIn = !!user && user.id !== 0

  const canViewReviews = isJapan || isLoggedIn

  return {
    canViewReviews,
    // 잠김 상태: 리뷰를 볼 수 없는 경우 true
    isLocked: !canViewReviews,
  }
}
